/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

/*
 * Partial fallback implementation for localStorage.
 */

define([
  "utils/browser"
], function(
  Browser
) {
  var tmpStorage = {};
  tmpStorage.removeItem = function (name) {
    delete tmpStorage[name];
  }
  tmpStorage.setItem = function (name, value) {
    tmpStorage[name] = value;
  }
  tmpStorage.getItem = function (name) {
    return tmpStorage[name];
  }

  if (Browser.localStorageAvailable()) {
    return localStorage;
  } else {
    return tmpStorage;
  }
});
